import * as React from "react";
import Btn from "@warda/library-ui/core/Btn";
const BtnLink = ({ url, label }) => {
    const onOpen = React.useCallback(() => {
        window.open(url, "_blank");
    }, [url]);
    return (React.createElement(Btn, { style: { width: 180 }, onClick: onOpen, icon: "chevron_right", labelPosition: "left", label: label, labelStyle: { textAlign: "left" } }));
};
export default BtnLink;
